const prefixes = [
  "comfortable",
  "composed",
  "cool",
  "easygoing",
  "peaceful",
  "placid",
  "poised",
  "quiet",
  "sedate",
  "smooth",
  "tranquil",
  "blazing",
  "burning",
  "combustible",
  "excitable",
  "fierce",
  "flaming",
  "glowing",
  "hot",
  "impassioned",
  "intense",
  "red-hot",
  "spirited",
  "vehement",
  "violent",
  "dependable",
  "logical",
  "persistent",
  "rational",
  "steady"
];

const suffixes = [
  "desert",
  "swamp",
  "pasture",
  "badlands",
  "marsh",
  "moorland",
  "wilds",
  "wasteland",
  "jungle",
  "bush",
  "tangle",
  "woodland",
  "mountains",
  "undergrowth",
  "solitude",
  "alliance"
];

const colours = ["red", "yellow", "pink", "green", "orange", "purple", "blue"];

const rand = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
};

export const getFunName = () => {
  const prefixesCount = prefixes.length;
  const prefix = prefixes[rand(0, prefixesCount)];

  const coloursCount = colours.length;
  const colour = colours[rand(0, coloursCount)];

  const suffixesCount = suffixes.length;
  const suffix = suffixes[rand(0, suffixesCount)];

  return `${prefix}-${colour}-${suffix}`;
};
